module.exports = __webpack_public_path__ + "static/media/image-howto-5.d980624d.jpg";